import React from 'react';
import { IntlShape } from 'react-intl';
import { MultiSelectButton } from '../../../../global/multi-select/multi-select-button';
import { IDeliveryItemDetailsDTO, IEntityRoleDTO } from '../../../../../api/events.dao';
import DeliveryTeamButton from './delivery-team-button';
import { MultiSelectWithRoleList } from '../../../../global/multi-select-with-role.tsx/multi-select-with-role-list';
import MultiSelectWithRoleHeader from '../../../../global/multi-select-with-role.tsx/multi-select-with-role-header';
import { addText, cancelText } from '../../../../../constants/common-labels.constants';

export interface IDeliveryTeamButtonWrapperProps {
  handleSearchDeliveryTeamItems: (query: string) => Promise<void>;
  setAssignedDeliveryTeam: (
    deliveryTeamMembers: IDeliveryItemDetailsDTO[],
    eventId: number,
    accountId: number
  ) => Promise<void>;
  removeDeliveryItem: (
      intl: IntlShape,
      deliveryMemberUserName: string,
      deliveryMemberUserId: string,
      eventId: number,
      accountId: number
  ) => Promise<void>;
  setDeliveryMemberRole: (
      intl: IntlShape,
      deliveryMemberUserName: string,
      deliveryMemberUserId: string,
      eventId: number,
      accountId: number,
      role: string
  ) => Promise<void>;
  intl: IntlShape;
  accountId: number;
  eventId: number;
  canRenderAddMembersButton: boolean;
  deliveryTeamItems: IDeliveryItemDetailsDTO[];
  sortedDeliveryTeamMembers: IDeliveryItemDetailsDTO[];
  trackCancelDeliveryTeamButtonMixPanel?: () => void;
  deliveryMemberRoles: IEntityRoleDTO[];
}


const DeliveryTeamButtonWrapper = (props: IDeliveryTeamButtonWrapperProps) => {
  const {
    canRenderAddMembersButton,
    deliveryTeamItems,
    handleSearchDeliveryTeamItems,
    setAssignedDeliveryTeam,
    intl,
    accountId,
    eventId,
    sortedDeliveryTeamMembers,
    removeDeliveryItem,
    setDeliveryMemberRole,
    trackCancelDeliveryTeamButtonMixPanel,
    deliveryMemberRoles,
  } = props;

  return canRenderAddMembersButton && !sortedDeliveryTeamMembers.length ?
      <MultiSelectButton
        text={'+ Add Delivery Team'}
        className='add-attendee-btn visible-on-hover'
        items={deliveryTeamItems}
        value={[]}
        keyProperty='username'
        nameProperty='fullName'
        applyButtonText={addText()}
        resetButtonText={cancelText()}
        popoverClassName={'multi-select-with-role event_form__items-section m-bottom-0px'}
        renderHeader={MultiSelectWithRoleHeader}
        renderSelectList={rest => <MultiSelectWithRoleList
          withSearchInput
          withUnassigned
          entityRoleKey='deliveryTeamMemberRole'
          intlRoleKey='deliveryTeamMemberRole'
          entityRolesList={deliveryMemberRoles}
          {...rest}
          intl={intl}
        />}
        filterHandler={handleSearchDeliveryTeamItems}
        searchWithDebounce
        onChange={teamMembers => setAssignedDeliveryTeam(teamMembers, eventId, accountId)}
        onCancel={trackCancelDeliveryTeamButtonMixPanel}
        onClickOutside={trackCancelDeliveryTeamButtonMixPanel}
      /> :
      sortedDeliveryTeamMembers.length ? <DeliveryTeamButton
        canRenderAddMembersButton={canRenderAddMembersButton}
        handleSearchDeliveryTeamItems={handleSearchDeliveryTeamItems}
        sortedDeliveryTeamMembers={sortedDeliveryTeamMembers}
        deliveryTeamItems={deliveryTeamItems}
        intl={intl}
        removeDeliveryItem={removeDeliveryItem}
        setDeliveryMemberRole={setDeliveryMemberRole}
        accountId={accountId}
        eventId={eventId}
        setAssignedDeliveryTeam={setAssignedDeliveryTeam}
        trackCancelDeliveryTeamButtonMixPanel={trackCancelDeliveryTeamButtonMixPanel}
        deliveryMemberRoles={deliveryMemberRoles}
      /> :
      <div className='delivery-team-column--disabled'></div>;
};

export default DeliveryTeamButtonWrapper;
